// Meta Pixel integration — loaded lazily and ONLY on public routes.
// Admin routes never initialise the pixel.

export const PIXEL_ID = "1554117622895917";

const ADMIN_PREFIX = "/admin";

function isAdminPath(pathname) {
  return typeof pathname === "string" && pathname.startsWith(ADMIN_PREFIX);
}

function loadPixelScript() {
  if (typeof window === "undefined") return;
  if (window.fbq) return; // already loaded
  // Standard Meta Pixel bootstrap
  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
}

/** Initialise pixel + fire first PageView. Safe to call multiple times. */
export function initPixel() {
  if (typeof window === "undefined") return;
  if (isAdminPath(window.location.pathname)) return;
  loadPixelScript();
  try {
    window.fbq("track", "PageView");
  } catch (_) {}
}

/** Fire a Meta standard event (e.g. Lead, Contact, ViewContent). */
export function trackStd(eventName, params) {
  if (typeof window === "undefined") return;
  if (isAdminPath(window.location.pathname)) return;
  loadPixelScript();
  try {
    if (params) window.fbq("track", eventName, params);
    else window.fbq("track", eventName);
  } catch (_) {}
}

/** Fire a Meta custom event (e.g. SmallTransportSelected). */
export function trackCustom(eventName, params) {
  if (typeof window === "undefined") return;
  if (isAdminPath(window.location.pathname)) return;
  loadPixelScript();
  try {
    if (params) window.fbq("trackCustom", eventName, params);
    else window.fbq("trackCustom", eventName);
  } catch (_) {}
}

/** Convenience: fire one or more standard + custom events together. */
export function track({ std = [], custom = [], params } = {}) {
  if (!Array.isArray(std)) std = [std];
  if (!Array.isArray(custom)) custom = [custom];
  std.forEach((n) => n && trackStd(n, params));
  custom.forEach((n) => n && trackCustom(n, params));
}
